import { FC } from 'react';
import { FormControlLabel } from '@mui/material';
import Check from 'src/pages/Van/components/item/CheckIcon';

const Extra: FC = () => {
  const extraArray = [
    'Unlimited Miles*',
    'Open 24 hours',
    'Add Delivery/Pickup',
    'Unmarked/No Logos'
  ];

  return (
    <div className='filter-extra'>
      <div className='filter__title'>Also Offered</div>
      <div className='filter__list'>
        {extraArray.map((extra, i) => (
          <FormControlLabel key={i} sx={{ cursor: 'default' }} control={<Check />} label={extra} />
        ))}
      </div>
    </div>
  );
};
export default Extra;
